var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#EBDFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1315_34920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 15.2083C12.7874 15.2083 13.0629 15.3225 13.2661 15.5256C13.4693 15.7288 13.5834 16.0043 13.5834 16.2917C13.5834 16.579 13.4693 16.8545 13.2661 17.0577C13.0629 17.2609 12.7874 17.375 12.5001 17.375C12.2128 17.375 11.9372 17.2609 11.734 17.0577C11.5309 16.8545 11.4167 16.579 11.4167 16.2917C11.4167 16.0043 11.5309 15.7288 11.734 15.5256C11.9372 15.3225 12.2128 15.2083 12.5001 15.2083ZM12.5001 11.4167C12.7874 11.4167 13.0629 11.5308 13.2661 11.734C13.4693 11.9371 13.5834 12.2127 13.5834 12.5C13.5834 12.7873 13.4693 13.0629 13.2661 13.266C13.0629 13.4692 12.7874 13.5833 12.5001 13.5833C12.2128 13.5833 11.9372 13.4692 11.734 13.266C11.5309 13.0629 11.4167 12.7873 11.4167 12.5C11.4167 12.2127 11.5309 11.9371 11.734 11.734C11.9372 11.5308 12.2128 11.4167 12.5001 11.4167ZM12.5001 7.625C12.7874 7.625 13.0629 7.73914 13.2661 7.9423C13.4693 8.14547 13.5834 8.42102 13.5834 8.70833C13.5834 8.99565 13.4693 9.2712 13.2661 9.47437C13.0629 9.67753 12.7874 9.79167 12.5001 9.79167C12.2128 9.79167 11.9372 9.67753 11.734 9.47437C11.5309 9.2712 11.4167 8.99565 11.4167 8.70833C11.4167 8.42102 11.5309 8.14547 11.734 7.9423C11.9372 7.73914 12.2128 7.625 12.5001 7.625Z",
    fill: "#6000E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1315_34920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOption);
export default __webpack_public_path__ + "static/media/option.9f524c2ec89bd80af0101fa4ca8da649.svg";
export { ForwardRef as ReactComponent };